import { render, staticRenderFns } from "./chart-bar-new-ux.vue?vue&type=template&id=216abfe9&"
import script from "./chart-bar-new-ux.vue?vue&type=script&lang=js&"
export * from "./chart-bar-new-ux.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216abfe9')) {
      api.createRecord('216abfe9', component.options)
    } else {
      api.reload('216abfe9', component.options)
    }
    module.hot.accept("./chart-bar-new-ux.vue?vue&type=template&id=216abfe9&", function () {
      api.rerender('216abfe9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/chart-bar-new-ux.vue"
export default component.exports